var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPythonLanguageIcon = function SvgPythonLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2c-2.3 0-4.2.2-4.2 2.6v1.9h4.3v.6H6.2c-2.4.6-3.2 2-3.2 4.4s.7 3.9 3.1 3.9h1.6v-2.3c0-1.9 1.6-3.5 3.5-3.5h4.2c1.5 0 2.7-1.2 2.7-2.7V4.6C18.1 3.2 16.6 2 12 2M9.4 3.5c.5 0 .9.4.9.9s-.4.9-.9.9-.9-.4-.9-.9.4-.9.9-.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22c2.3 0 4.2-.2 4.2-2.6v-1.9h-4.3v-.6h5.9c2.3 0 3.1-1.4 3.1-3.8s-.7-3.9-3.1-3.9h-1.6v2.3c0 1.9-1.6 3.5-3.5 3.5H8c-1.5 0-2.7 1.2-2.7 2.7v3.8c.6-.7 2.1.5 6.7.5m2.6-1.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9"
  })));
};
export default SvgPythonLanguageIcon;